import React from "react";
import { InputComponent } from "../InputComponent";
import DownRightArrow from "../../../../assets/icons/DownRightArrow";

interface RegistrationCodeSectionProps {
  id: string;
  name: string;
  value: string;
  rcPrefix: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  verificationResult?: string | null;
}

const RegistrationCodeSection: React.FC<RegistrationCodeSectionProps> = ({
  id,
  name,
  value,
  rcPrefix,
  onChange,
  verificationResult,
}) => {
  return (
    <div className="w-full flex pl-1 mt-3 gap-4 animate-slide-down">
      <span className="">
        <DownRightArrow />
      </span>
      <div className="w-full bg-[#F9FAFB] p-3 border border-gray-300 rounded-lg">
        <div className="flex gap-1 items-center text-[14px]">
          <p className="text-[14px] leading-5 text-[#000000] pb-2">
            Registration code
          </p>
        </div>
        <InputComponent
          placeholder={`Enter your code (e.g. ${rcPrefix}654321)`}
          name={name}
          type="text"
          value={value}
          handleChange={onChange}
          className="w-full h-10 md:h-12 max-md:mt-[-2px] md:text-[16px] text-[13px] md:placeholder:text-[16px] placeholder:text-[13px] placeholder:text-[#98A2B3] border-gray-300 rounded-md"
        />

        {verificationResult && (
          <p
            className={`animate-slide-down flex-wrap max-w-[500px] mt-1 md:text-[14px] text-[12px] ${
              verificationResult === "Verifying registration code..."
                ? "text-[#20A852]"
                : verificationResult.includes("failed") ||
                    verificationResult.includes("Invalid") ||
                    verificationResult.includes("requires") ||
                    verificationResult.includes("Invalid registration code")
                  ? "text-[#D82020]"
                  : "text-[#20A852]"
            }`}
          >
            {verificationResult}
          </p>
        )}
      </div>
    </div>
  );
};

export default RegistrationCodeSection;
